import { X } from "lucide-react";

const DisburseType = ({
  closeDisburseType,
  handleChooseDisbursePhone,
  handleAccountNumber,
  disburseDetails,
  setDisburseDetails,
}) => {
  const handleNext = () => {
    if (!disburseDetails.disburseType) {
      return;
    }
    if (disburseDetails.disburseType === "MPESA") {
      handleChooseDisbursePhone();
    } else if (disburseDetails.disburseType === "BANK") {
      handleAccountNumber();
    }
  };
  return (
    <div
      onClick={(e) => {
        closeDisburseType();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[800px] h-[500px] rounded-[10px] py-[20px] px-[40px] relative bg-white"
      >
        <div
          onClick={closeDisburseType}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div>
          <p className="text-[#000000] font-semibold text-[20px]">
            Choose Disbursement Type
          </p>
          <p className="text-[#5C5C5C] font-normal text-[14px]">
            Choose how the loan funds will be disbursed. You can select Bank
            Transfer or M-PESA as the recipient’s preferred method. Ensure all
            details are accurate before proceeding.
          </p>
          {/* Disburse Type Options */}
          <div className="flex flex-col my-[20px] gap-[20px] w-full">
            <label className="flex items-center space-x-2 cursor-pointer">
              <input
                type="radio"
                name="paymentMethod"
                value="MPESA"
                checked={disburseDetails.disburseType === "MPESA"}
                onChange={(e) =>
                  setDisburseDetails({
                    ...disburseDetails,
                    disburseType: e.target.value,
                  })
                }
                className="accent-blue-600 w-4 h-4"
              />
              <span className="text-sm text-gray-700">MPESA</span>
            </label>

            <label className="flex items-center space-x-2 cursor-pointer">
              <input
                type="radio"
                name="paymentMethod"
                value="BANK"
                checked={disburseDetails.disburseType === "BANK"}
                onChange={(e) =>
                  setDisburseDetails({
                    ...disburseDetails,
                    disburseType: e.target.value,
                  })
                }
                className="accent-blue-600 w-4 h-4"
              />
              <span className="text-sm text-gray-700">BANK</span>
            </label>
          </div>
        </div>
        <div className="absolute bottom-[20px] right-[20px] flex items-center justify-center gap-[10px]">
          <button
            onClick={closeDisburseType}
            className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#5C5C5C] font-medium"
          >
            Close
          </button>
          <button
            onClick={handleNext}
            className="h-[35px] bg-[#000000] rounded-[30px] px-[15px] text-[#FFFFFF] font-medium"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisburseType;
